import { useState } from 'react';

function YearPicker({ startYear = 2000, endYear = new Date().getFullYear(), options }) {
  const [year, setYear] = useState(endYear);

  const values = Array.isArray(options)
    ? options
    : Array.from({ length: endYear - startYear + 1 }, (_, i) => startYear + i);

  return (
    <select value={year} onChange={(e) => setYear(Number(e.target.value))}>
      {values.map((value) => (
        <option key={value} value={value}>
          {value}
        </option>
      ))}
    </select>
  );
}

export default YearPicker;